export const normalizeBenefitsDocument = (value) => value.replace(/[^a-z0-9]/gi, '').toUpperCase();
export const isBenefitsCompanyDocument = (value) => /^[A-Z0-9]{14}$/.test(value);
